/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Warm_Falcon_SoarInputs */

const en_bold_warm_falcon_soar = /** @type {(inputs: Bold_Warm_Falcon_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approving…`)
};

const de_bold_warm_falcon_soar = /** @type {(inputs: Bold_Warm_Falcon_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird genehmigt…`)
};

/**
* | output |
* | --- |
* | "Approving…" |
*
* @param {Bold_Warm_Falcon_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_warm_falcon_soar = /** @type {((inputs?: Bold_Warm_Falcon_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Warm_Falcon_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_warm_falcon_soar(inputs)
	return de_bold_warm_falcon_soar(inputs)
});